import React from "react";
import TruncatedTooltip from "../TruncatedTooltip";

interface TruncatedGridCellProps {
  value: string;
  placement?:
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";
}

/**
 * A reusable grid cell component that displays text with truncation and tooltip.
 * Used to reduce duplication in data grid column render functions.
 */
const TruncatedGridCell: React.FC<TruncatedGridCellProps> = ({
  value,
  placement = "top-start",
}) => {
  return (
    <TruncatedTooltip title={value} placement={placement}>
      <span
        style={{
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "block",
        }}
      >
        {value}
      </span>
    </TruncatedTooltip>
  );
};

export default TruncatedGridCell;
